export default __webpack_public_path__ + "static/media/sidebar-icon-community.3c3acb29.svg";